<template>
  <div>
    <h2 class="subtitle is-5">{{ title }}</h2>
    <b-loading :is-full-page="false" :active="loading"></b-loading>
    <slot v-if="!loading"></slot>
  </div>
</template>

<script>
export default {
  name: 'UserSetting',
  props: ['loading', 'title'],
};
</script>

<style scoped lang="scss">

</style>
